import { MedicalPaAnalyticsPayload } from "../../data-model/analyticsDatamodel";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logDataToConsole, logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

interface MedicalPaAnalyticsResponse {
  data?: any;
}

export const getMedicalPaAnalytics = async (
  payload: MedicalPaAnalyticsPayload,
): Promise<MedicalPaAnalyticsResponse> => {
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.GET_MEDICAL_PA_ANALYTICS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Medical PA analytics fetch failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }

    const result = await response.json();
    logDataToConsole("Medical PA analytics fetch successful", result);
    return result;
  } catch (error) {
    logError(error as Error, "Error in getMedicalPaAnalytics");
    throw error;
  }
};
